/** Shared scroll surface — use on the one element that should scroll in a shell. */
export const INORA_SCROLL_SURFACE_CLASS =
  "inora-scroll-surface min-h-0 flex-1 flex-col overflow-x-hidden overflow-y-auto overscroll-y-contain scroll-smooth";

/** Outer shell that constrains height so the inner scroll surface can scroll. */
export const INORA_SCROLL_SHELL_CLASS =
  "flex h-[100svh] min-h-0 flex-col overflow-hidden";
